$(document).on('turbolinks:load', function() {
  $('#employees-table').dataTable({
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": $('#employees-table').data('source')
    },
    "pagingType": "full_numbers",
    "columns": [
      {"data": "name"},
      {"data": "mobile"}, 
      {"data": "email"}, 
      {"data": "ops"},
    ], 
    columnDefs: [{ "orderable": false, "targets": 3 }, { "width": "5%", "targets": 3 },{ "className": 'dt-center', "targets": 3 }]
  });
});